function ValidatedToken(props) {
  const validationResult = props.validationResult;

  if (!validationResult) {
    return <div></div>; 
  }

  const valStatus = validationResult.status;
  const valMessage = validationResult.message;

  const successDisplay = <div className="success success-title">
    <i aria-hidden="true" className="fa fa-check-circle"></i>
    <span  className="spc-ml-15">{valMessage}</span>
  </div>

  function ErrorMsgDisplay() {   
    const msgDisplay = valMessage.map((message) => {
      return <div>{message}</div>
    });
    return <div className="error error-detail">{msgDisplay}</div>    
  }

const errorDisplay = <div>
  <div className="error error-title">
    <i aria-hidden="true" className="fa fa-exclamation-circle"></i>
    <span  className="spc-ml-15">Token is not valid</span>      
  </div>
  <div  className="error error-header">Validation error details:</div>
  <ErrorMsgDisplay></ErrorMsgDisplay>
  </div>

  const resultDisplay = valStatus?.toLowerCase() === 'error' ? errorDisplay : successDisplay;

return resultDisplay; 
}

export default ValidatedToken;